import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { IconButton, Tooltip } from '@mui/material';
import type { MouseEvent } from 'react';
import { useNotify } from 'react-admin';

type Props = {
  id: string;
  label?: string;
};

export const CopyIdButton = ({ id, label = 'Скопировать ID' }: Props) => {
  const notify = useNotify();

  const handleCopy = async (event: MouseEvent) => {
    event.stopPropagation();

    try {
      await navigator.clipboard.writeText(id);
      notify('ID скопирован', { type: 'info' });
    } catch (error) {
      console.error(error);
      notify('Не удалось скопировать ID', { type: 'warning' });
    }
  };

  return (
    <Tooltip title={label}>
      <IconButton size="small" onClick={handleCopy} aria-label={label}>
        <ContentCopyIcon fontSize="inherit" />
      </IconButton>
    </Tooltip>
  );
};
